import { render, staticRenderFns } from "./passengerItemV2.vue?vue&type=template&id=0138d5f4&"
import script from "./passengerItemV2.vue?vue&type=script&lang=js&"
export * from "./passengerItemV2.vue?vue&type=script&lang=js&"
import style0 from "./passengerItemV2.vue?vue&type=style&index=0&id=0138d5f4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports